import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormGroup, FormsModule } from '@angular/forms';
import { FieldArrayType, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'repeat-label-section',
  standalone: true,
  imports: [CommonModule, FormsModule, FormlyModule, DropdownModule],
  styleUrls: ['../../config-page/config-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
  <div class="cards-container">
    <!-- Campo ricerca UNICO sopra tutte le card -->
    <div class="mb-4 flex flex-col md:flex-row md:items-center gap-2">
      <input
        type="text"
        class="form-input w-full md:w-1/3 px-3 py-2 border rounded"
        placeholder="Cerca..."
        [(ngModel)]="searchText"
        (ngModelChange)="page = 1"
      />
      <div class="flex items-center gap-2 md:ml-auto">
        <label>Per pagina:</label>
        <p-dropdown
            [options]="pageSizeOptions"
            [(ngModel)]="pageSize"
            (onChange)="page = 1"
            [style]="{'width':'100px'}"
            [showClear]="false"
            [appendTo]="'body'">
        </p-dropdown>
        </div>
    </div>
    <!-- Card filtrate e paginazione -->
    <div *ngFor="let row of pagedRows(); let i = index" class="form-card">
      <div class="card-header iconPosition">
        <button type="button" class="btn-close" (click)="remove(getAbsoluteIndex(i))" aria-label="Rimuovi">
          <i class="fa-solid fa-trash"></i>
        </button>
      </div>
        <div class="card-body">
    <!-- Campi principali in riga -->
        <div class="flex flex-col md:flex-row gap-4 w-full">
          <ng-container *ngFor="let col of columns.slice(0, columns.length - 1); let j = index">
            <div class="form-group flex-1 min-w-0">
              <formly-field *ngIf="row.fieldGroup && row.fieldGroup[j]" [field]="row.fieldGroup[j]"></formly-field>
            </div>
          </ng-container>
        </div>
        <!-- Repeat annidato in fondo, su una nuova riga e a tutta larghezza -->
        <div class="mt-4 w-full">
          <formly-field *ngIf="row.fieldGroup && row.fieldGroup[columns.length - 1]" [field]="row.fieldGroup[columns.length - 1]"></formly-field>
        </div>
      </div>
    </div>
    <!-- Paginazione -->
    <div class="flex justify-center items-center gap-2 my-4" *ngIf="totalPages() > 1">
      <button class="btn" [disabled]="page === 1" (click)="page = page - 1">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <span>Pagina {{ page }} di {{ totalPages() }}</span>
      <button class="btn" [disabled]="page === totalPages()" (click)="page = page + 1">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
    <button type="button" class="add-button" (click)="add()">
      <i class="fa-solid fa-plus"></i>
      {{ field.templateOptions?.addText || 'Aggiungi' }}
    </button>
  </div>
  `
})
export class RepeatLabelSectionComponent extends FieldArrayType {
  searchText: string = '';
  page: number = 1;
  pageSize: number = 5;
  pageSizeOptions = [
  { label: '5', value: 5 },
  { label: '10', value: 10 },
  { label: '20', value: 20 }
];

  get columns() {
    const arrayConfig = this.field.fieldArray;
    return typeof arrayConfig === 'function' ? [] : arrayConfig?.fieldGroup || [];
  }

  filteredRows() {
    if (!this.searchText) {
      return this.field.fieldGroup || [];
    }
    const search = this.searchText.toLowerCase();
    return (this.field.fieldGroup || []).filter(row =>
      (row.fieldGroup || []).some(field =>
        field?.formControl?.value &&
        field.formControl.value.toString().toLowerCase().includes(search)
      )
    );
  }

  pagedRows() {
    const rows = this.filteredRows();
    const start = (this.page - 1) * this.pageSize;
    return rows.slice(start, start + this.pageSize);
  }

  totalPages() {
    return Math.ceil(this.filteredRows().length / this.pageSize) || 1;
  }

  getAbsoluteIndex(i: number): number {
    return (this.page - 1) * this.pageSize + i;
  }

  override add(): void {
    if (this.form.valid) {
      super.add();
    } else {
      this.markFormFieldsTouched(this.form);
    }
  }

  markFormFieldsTouched(formGroup: FormGroup | FormArray) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if ((control as any).controls) {
        this.markFormFieldsTouched(control as FormGroup | FormArray);
      }
    });
  }
}
